export default "__VITE_ASSET__dc202523__"